export default "__VITE_ASSET__DLhwKfM2__"